import React, { useState } from "react";

export default function CCTM_route(props) {
    
    let Component = props.component;
    
    if (typeof props.postRender == "function"){
        Component = props.postRender(props.component,props)
    }     
   
    return <Component {...props} onClick={Component.onClick}  />
}